import React, { useEffect, useRef, memo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { PDFPageProxy } from 'pdfjs-dist/types/src/pdf';
import styles from './pdfPreviewSideSlide.module.css';

interface PdfPageRow {
  pageNumber: number;
  page: PDFPageProxy;
}

const PdfPageCellRenderer = memo(({ data }: ICellRendererParams<PdfPageRow>) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current && data?.page) {
      const viewport = data.page.getViewport({ scale: 0.5 });
      const canvas = canvasRef.current;
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      const context = canvas.getContext('2d');
      if (context) {
        data.page.render({
          canvasContext: context,
          viewport,
        });
      }
    }
  }, [data]);

  if (!data) return null;

  return (
    <div className={styles.pageWrapper}>
      <canvas
        ref={canvasRef}
        className={styles.canvasPointer}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          border: '1px solid #d2d2d2',
          cursor: 'pointer',
        }}
      />
      <div style={{
        marginTop: '-10px',
        fontSize: '12px',
        textAlign: 'center',
        color: '#555',
        height: '30px',
      }}
      >
        {data.pageNumber}
      </div>
    </div>
  );
});

PdfPageCellRenderer.displayName = 'PdfPageCellRenderer';

export default PdfPageCellRenderer;
